import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private currentAccommodationIndex = 0;
  private currentActivityIndex = 0;
  private travelPrice;

  constructor(
    @Inject(PLATFORM_ID) private platform: Object,
    private analytics: AngularFireAnalytics
  ) { }

  logEvent(eventName, eventParams?) {
    // console.log('\n\n\n ---------------------- Analytics Call -----------------------');
    // console.log('eventName = ' + eventName);
    // console.log(eventParams);
    // console.log('---------------------- Analytics Call -----------------------\n\n\n');
    if (isPlatformBrowser(this.platform)) {
      
      if (eventParams) {
        this.analytics.logEvent(eventName, eventParams);
      } else {
        this.analytics.logEvent(eventName);
      }
      
    }
  }

  getFullAnalyticsParams(tripObject, accommodation_index?, activity_index?, flightPrice?) {
    //  this was added due to ghost response {when the trip response is being returned as {} empty obj}
    if (!tripObject.data) {
      return {};
    }
    this.currentAccommodationIndex = accommodation_index || accommodation_index === 0 ?
    accommodation_index : this.currentAccommodationIndex;
    const accommodation = tripObject.data.accommodations[this.currentAccommodationIndex];
    this.currentActivityIndex = activity_index || activity_index === 0 ? activity_index : this.currentActivityIndex;
    const activity = tripObject.data.activities[this.currentActivityIndex];
    this.travelPrice = flightPrice || flightPrice === 0 ? flightPrice : this.travelPrice;
    const travePrice = this.travelPrice ? this.travelPrice : tripObject.data.travel.quote.MinPrice;

    const params = {
      accommodation_count: tripObject.data.accommodations.length,
      accom_name: accommodation.hotel_object.name,
      accom_price_per_night: accommodation.min_price,
      accom_price_total: accommodation.min_total_price,
      no_of_people: tripObject.data.trip.people,
      children_count: tripObject.data.trip.children,
      infants_count: tripObject.data.trip.infants,
      no_of_nights: tripObject.data.trip.accommodation_days,
      total_price: this.tripTotalMockupPrice(tripObject),
      travel_price_per_person: travePrice,
      travel_price_total: travePrice * tripObject.data.trip.people,
      origin_airport: tripObject.data.travel.airport_origin.iata_code,
      activity_name: activity.name,
      place_name: tripObject.data.travel.destination.city,
      activity_count: tripObject.data.activities.length,
      accom_genius: accommodation.hotel_object.is_genius === 0 ? 'no' : 'yes',
      luckyframe_hit: tripObject.data.trip.luckyframe_hit === 0 ? 'no' : 'yes',
      flight_type: tripObject.data.travel.quote.Direct ? 'direct' : 'indirect',
      days_until_leave: moment(tripObject.data.trip.from_date).diff(moment(), 'days'),
      budget: tripObject.data.trip.budget,
      country: tripObject.data.travel.country_origin.name,
      start_date: tripObject.data.trip.from_date,
      end_date: tripObject.data.trip.to_date,
      flags: this.collectFlags(tripObject),
      accommodations_genius_count: this.collectAccommodationsGeniusCount(tripObject.data.accommodations),
    };
    return params;
  }

  tripTotalMockupPrice(tripObject) {
    const accommodationPrice = tripObject.data.accommodations[0].min_total_price;
    const transportationPrice = tripObject.data.travel.quote.MinPrice;
    const pplNumber = tripObject.data.trip.people;
    const totalTripPrice = Math.ceil((accommodationPrice / pplNumber) + transportationPrice);
    return totalTripPrice;
  }

  collectFlags(tripObject) {
    const tripData = tripObject.data.trip;
    const flags = [];
    if (tripData.adventure_flag) {
      flags.push('adventure');
    }
    if (tripData.beach_flag) {
      flags.push('beach');
    }
    if (tripData.chill_flag) {
      flags.push('chill');
    }
    if (tripData.culture_flag) {
      flags.push('culture');
    }
    if (tripData.food_flag) {
      flags.push('food');
    }
    if (tripData.hot_flag) {
      flags.push('hot');
    }
    if (tripData.nightlife_flag) {
      flags.push('nightlife');
    }
    if (tripData.off_grid_flag) {
      flags.push('off_grid');
    }
    if (tripData.romantic_flag) {
      flags.push('romantic');
    }
    if (tripData.sports_flag) {
      flags.push('sports');
    }
    if (tripData.winter_flag) {
      flags.push('winter');
    }
    if (tripData.winter_sports_flag) {
      flags.push('winter_sports');
    }
    if (flags.length > 0) {
      return flags.join('|');
    } else {
      return 'everything';
    }
  }

  setUserProperties() {
    if (isPlatformBrowser(this.platform)) {

      this.analytics.setUserProperties(this.getUserProperties());
      if (this.getUserObj()) {
        this.analytics.setUserId(this.getUserObj().id);
      } else {
        this.analytics.setUserId(null);
      }

    }
  }

  getUserProperties() {
    const userConfig = this.getLuckyUserConfig();
    const userObj = this.getUserObj();
    if (Object.keys(userConfig).length === 0 && userConfig.constructor === Object) {
      return;
    }
    const userProps = {
      budget: userConfig.budget,
      airports_iata: userConfig.airports.join('|'),
      dates_type: userConfig.date.luckyDates ? 'lucky' : (userConfig.date.luckyCalender ? 'manual' : 'lucky' ),
      accommodation_type: this.getAccommodationTypes(userConfig.accommodation),
      people_count: userConfig.people,
      children_count: userConfig.children.length,
      flags: userConfig.flags.join('|'),
      from_date: userConfig.date.luckyCalender ? userConfig.date.date.from : null,
      to_date: userConfig.date.luckyCalender ? userConfig.date.date.to : null,
      number_of_nights: userConfig.date.luckyDates ?
        (userConfig.date.date.nights ? userConfig.date.date.nights : userConfig.date.date.nights === 0 ? 'Any' : null) : null,
      selected_months: userConfig.date.luckyDates ? userConfig.date.date.months.join('|') : null,
      weekends: userConfig.date.luckyDates ? userConfig.date.date.weekends : null,
      user_id: userObj ? userObj.id : null,
      email: userObj ? userObj.email : null,
      first_name: userObj ? userObj.profile.first_name : null,
      last_name: userObj ? userObj.profile.last_name : null,
      created: userObj ? userObj.created_at : null,
    };
    return userProps;
  }

  getLuckyUserConfig() {
    let conf;
    if (isPlatformBrowser(this.platform)) {
      conf = localStorage.getItem('LuckyUserConfig');
      if (conf) {
        return JSON.parse(conf);
      } else {
        return {};
      }
    } else {
      return {};
    }
  }

  getUserObj() {
    let obj;
    if (isPlatformBrowser(this.platform)) {
      obj = localStorage.getItem('user');
      if (obj) {
        return JSON.parse(obj);
      } else {
        return obj;
      }
    } else {
      return obj;
    }
  }

  getAccommodationTypes(typesArray) {
    if (typesArray.length >= 3) {
      return 'all';
    } else {
      const accommodationTypes = [];
      if (typesArray.includes(1)) {
        accommodationTypes.push('Hostel');
      }
      if (typesArray.includes(2)) {
        accommodationTypes.push('Hotel');
      }
      if (typesArray.includes(3)) {
        accommodationTypes.push('Apartment');
      }
      if (accommodationTypes.length <= 0 ) {
        return null;
      }
      return accommodationTypes.join('|');
    }
  }

  getCheckoutParams(checkoutObj) {
    const params = {
      platform: checkoutObj.platform,
      currency: checkoutObj.currency_code,
      price: parseInt(checkoutObj.trip_amount, 10),
      origin: checkoutObj.trip.destination.name,
      destination: checkoutObj.trip.destination.city,
      start_date: checkoutObj.trip.from_date,
      end_date: checkoutObj.trip.to_date,
      number_of_passengers: checkoutObj.number_of_people,
      number_of_children: checkoutObj.number_of_children,
      number_of_infants: checkoutObj.number_of_infants,
      number_of_nights: checkoutObj.trip.trip_days,
      number_of_rooms: checkoutObj.trip.accommodation.rooms.length,
      checkout_id: checkoutObj.id,
      coupon: checkoutObj.vouchers.length > 0 ?
      checkoutObj.vouchers[0].voucherName : (checkoutObj.gift_cards.length > 0 ? checkoutObj.gift_cards[0].giftCardName : null),
      coupon_value: checkoutObj.vouchers.length > 0 ?
      checkoutObj.vouchers[0].discount_amount : (checkoutObj.gift_cards.length > 0 ? checkoutObj.gift_cards[0].discount_amount : null),
      wallet_amount: checkoutObj.wallets.length > 0 ? checkoutObj.wallets[0].discount_amount : null,
      accommodation_genius: checkoutObj.trip.accommodation.is_genius === 0 ? 'no' : 'yes',
      payment_option: checkoutObj.payment_option,
    };
    if (checkoutObj.trip.campaign_tags) {
      for (const [key, value] of Object.entries(checkoutObj.trip.campaign_tags)) {
        params[`_CP_${key}`] = value;
      }
    }
    return params;
  }

  collectAccommodationsGeniusCount(accommodationsArray) {
    let count = 0;
    accommodationsArray.forEach(accommodation => {
      if (accommodation.hotel_object.is_genius === 1) {
        count = count + 1;
      }
    });
    return count;
  }

}
